import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { cloneDeep } from 'lodash-es';
import { Observable } from 'rxjs';

import { ProgramPeriodDialogComponent } from '../components/program-period-dialog/program-period-dialog.component';
import { SelectDaysDialogComponent } from '../components/select-days-dialog/select-days-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class TimemanagerDialogService {
  scheduleEntryPeriodDialogRef: MatDialogRef<ProgramPeriodDialogComponent>;
  selectDaysDialogRef: MatDialogRef<SelectDaysDialogComponent>;

  constructor(private dialog: MatDialog) {}

  openScheduleEntryPeriodDialog(data: any): Observable<any> {
    this.scheduleEntryPeriodDialogRef = this.dialog.open(ProgramPeriodDialogComponent, {
      width: '580px',
      panelClass: 'periods-dialog',
      disableClose: true,
    });

    this.scheduleEntryPeriodDialogRef.componentInstance.dataDialog = cloneDeep(data);

    return this.scheduleEntryPeriodDialogRef.afterClosed();
  }

  openSelectDaysDialog(): Observable<any> {
    this.selectDaysDialogRef = this.dialog.open(SelectDaysDialogComponent, {
      width: '400px',
      panelClass: 'select-days-dialog',
      disableClose: true,
    });

    return this.selectDaysDialogRef.afterClosed();
  }
}
